import { render, staticRenderFns } from "./ActiveScreen.vue?vue&type=template&id=1539ec20&scoped=true&"
import script from "./ActiveScreen.vue?vue&type=script&lang=js&"
export * from "./ActiveScreen.vue?vue&type=script&lang=js&"
import style0 from "./ActiveScreen.vue?vue&type=style&index=0&id=1539ec20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1539ec20",
  null
  
)

export default component.exports